export const getImageDomain = urls => {
  return urls.filter(url => url.strategy === "image").map(url => url.domain);
};

export const getAjaxDomain = urls => {
  return urls.filter(url => url.strategy === "ajax").map(url => url.domain);
};
